module.exports = "/img/logo-unitel-purple.svg?0e28102e38ce6d261a602b6a9bb6e289";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/logo-unitel-purple.svg
// module id = 6xH8
// module chunks = 46